module.exports = __webpack_public_path__ + "static/Home_Feature_2-9f9c3e09df16781088fd300459b1abf0.jpg";